var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1486.81 679.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{fill:#3756a6;}.cls-12,.cls-13,.cls-14,.cls-15,.cls-4,.cls-6{fill-rule:evenodd;}.cls-5{clip-path:url(#clip-path-3);}.cls-17,.cls-6{fill:#3856a6;}.cls-12,.cls-7{fill:#564b47;}.cls-13,.cls-8{fill:#3755a5;}.cls-15,.cls-9{fill:#ee3e23;}.cls-10,.cls-14{fill:#f8d316;}.cls-11{clip-path:url(#clip-path-4);}.cls-16{clip-path:url(#clip-path-5);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1486.81,
    height: 679.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 54.08,
    width: 395.65,
    height: 324.08
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 454.95,
    y: 148.85,
    width: 996.96,
    height: 134
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 720.34,
    y: 322.62,
    width: 372.8,
    height: 356.73
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1486.81,
    height: 679.35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0428\\u0430\\u0440_2",
    "data-name": "\\u0428\\u0430\\u0440 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0428\\u0430\\u0440_1-2",
    "data-name": "\\u0428\\u0430\\u0440 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0412\\u0435\\u043A\\u0442\\u043E\\u0440\\u043D\\u0438\\u0439_\\u0441\\u043C\\u0430\\u0440\\u0442-\\u043E\\u0431_\\u0454\\u043A\\u0442",
    "data-name": "\\u0412\\u0435\\u043A\\u0442\\u043E\\u0440\\u043D\\u0438\\u0439 \\u0441\\u043C\\u0430\\u0440\\u0442-\\u043E\\u0431\\u2019\\u0454\\u043A\\u0442"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.47,54.08H374.18a21.53,21.53,0,0,1,21.46,21.47V356.69a21.53,21.53,0,0,1-21.46,21.47H21.47A21.53,21.53,0,0,1,0,356.69V75.55A21.53,21.53,0,0,1,21.47,54.08m6.09,5A20.8,20.8,0,0,0,6.82,79.79V351.43a20.8,20.8,0,0,0,20.74,20.74H368.34a20.8,20.8,0,0,0,20.74-20.74V79.79a20.8,20.8,0,0,0-20.74-20.74Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "213.83 90.15 271.81 148.78 244.13 148.79 216.35 120.67 87.16 254.49 318.44 254.49 251.69 187.5 198.78 242.29 172.02 242.21 252.39 158.99 366.35 274.14 36.18 274.14 213.83 90.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "124.52 292.58 150.23 292.56 97.81 346.85 71.82 346.82 124.52 292.58"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M559.69,162.16l-3.11,21.15A48.88,48.88,0,0,0,541,172.12a45.21,45.21,0,0,0-18.33-3.7,49.74,49.74,0,0,0-18.81,3.52A40.16,40.16,0,0,0,489.06,182,54,54,0,0,0,478,199.76a57.23,57.23,0,0,0-3.84,20.75q0,19.13,11.71,31.13t30.33,12a50,50,0,0,0,17.89-3.23,60.57,60.57,0,0,0,16.62-9.58l-4.3,23.72a105.82,105.82,0,0,1-16.25,4.94,72.34,72.34,0,0,1-14.94,1.64q-27.06,0-43.66-16.54T455,221.2a76.35,76.35,0,0,1,5.28-28.28,66.79,66.79,0,0,1,15-23.11A61.84,61.84,0,0,1,496,156a66.19,66.19,0,0,1,25-4.73A79,79,0,0,1,542.58,154a53.73,53.73,0,0,1,17.11,8.16m9,115.68,16.22-123.79h19.45L598.07,201h59.85L664,154.05h19.63L667.15,277.84H647.79l7.76-59.21H595.79L588,277.84Zm126.57,0,16.24-123.79h69.46l-2.2,17.49H728.46l-4,31.16h50.08L772.3,220H722l-5.13,40h50.23l-2.45,17.83Zm209.68-63,.84,63H925l-5.72-129-52.14,79.78c-2,3.12-3.89,6.23-5.62,9.38s-3.29,6.35-4.77,9.55c-.72-2.74-1.55-5.57-2.51-8.4s-2.13-6.23-3.66-10.18l-30-80.13-40.66,129h19.71l18.59-63.39.08-.35c2.14-7.42,3.32-12.9,3.55-16.39,1.24,4.33,2.22,7.7,3,10.1s1.39,4.38,2,6l25.62,69.08L897,213.61c2.42-3.61,4.27-6.61,5.54-9a41.63,41.63,0,0,0,3-6.93c-.24,2.36-.38,4.7-.49,7s-.18,4.71-.18,7.19Zm37.69,63,16.24-123.79h19.77L962.13,277.84Zm76.52-70.46h6.52q18.25,0,24.9-4.36c4.42-2.91,6.64-7.94,6.64-15q0-9-5.57-12.64c-3.72-2.43-10.93-3.64-21.58-3.64h-6.26Zm-9.23,70.46H990.53l16.24-123.79h25.62c9.87,0,17,.58,21.3,1.7a30.55,30.55,0,0,1,11.57,5.75,29,29,0,0,1,8.54,11,35.41,35.41,0,0,1,3,14.66,41.24,41.24,0,0,1-3.44,17.14,33.11,33.11,0,0,1-9.93,12.67,34.11,34.11,0,0,1-13.07,6.23q-7.53,1.86-23.26,1.88h-10.21Zm75.66,0,16.21-123.79h19.45l-13.68,104.74h46.23l-2.63,19Zm66,0h21.09L1189,248.58h49.26l10.07,29.26h20.11l-45.22-128.63Zm45.18-45.71,16.07-30.27c1.19-2.31,2.37-4.75,3.59-7.38s2.45-5.4,3.69-8.34c.72,4,1.32,7.13,1.84,9.55s1,4.38,1.45,5.83l9.55,30.61Zm70.64,24.42L1281,245.29c3.37,6.78,7,11.66,10.9,14.69a21.75,21.75,0,0,0,13.74,4.53q9.78,0,15.9-5.74t6.08-15a18.61,18.61,0,0,0-3.2-11q-3.24-4.5-11.34-9.26c-1.12-.67-2.79-1.62-5-2.86q-13.9-7.69-18.73-13a25.33,25.33,0,0,1-5.2-8.77,33.08,33.08,0,0,1-1.73-10.82q0-16.32,10.47-26.61t27.39-10.27a41.5,41.5,0,0,1,20,4.64,37.46,37.46,0,0,1,14.17,13.91l-11.83,10.88a31.08,31.08,0,0,0-9.2-10,20.39,20.39,0,0,0-11.32-3.29q-9.12,0-14.8,5.31a18,18,0,0,0-5.65,13.79q0,10.13,16.33,18.9c2.71,1.41,4.76,2.54,6.17,3.41,8.32,4.82,14.2,9.86,17.66,15.06s5.2,11.6,5.2,19.16q0,17.58-11.34,27.93c-7.53,6.89-17.81,10.36-30.76,10.36q-13.2,0-22.53-6.09t-15-18.49m117,21.29,14-106H1365l2.37-17.83h84.55l-2.46,17.83h-31.54l-14,106Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1031.58,
    y: 3.76,
    width: 48.84,
    height: 120
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1033.21,
    y: 5.57,
    width: 45.58,
    height: 116.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 983.94,
    y: 3.75,
    width: 48.83,
    height: 119.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 985.56,
    y: 5.56,
    width: 45.58,
    height: 116.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 935.4,
    y: 3.75,
    width: 48.83,
    height: 119.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 937.02,
    y: 5.56,
    width: 45.58,
    height: 116.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1028.33,
    y: 0.15,
    width: 55.33,
    height: 127.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1033.21,
    y: 5.57,
    width: 45.58,
    height: 116.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 980.69,
    y: 0.14,
    width: 55.33,
    height: 127.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 985.56,
    y: 5.56,
    width: 45.58,
    height: 116.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 932.02,
    width: 55.59,
    height: 127.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 937.02,
    y: 5.56,
    width: 45.58,
    height: 116.38
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M960.39,521l1.1,0a75.33,75.33,0,0,0,73.24-75.3v-123h58.41v144A115.58,115.58,0,0,1,985.23,581.92c-1,.07-1.85.26-2.91.26H897.4a9.55,9.55,0,0,0-9.16,9.35v87.81H825V560.63h.15A43.38,43.38,0,0,1,868.35,521h92Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M868.35,526.4h.15c30.29.12,60.6,0,90.9,0h2.24v0a80.76,80.76,0,0,0,78.52-80.74V328.07h47.54V466.61A110.13,110.13,0,0,1,984.87,576.49c-1,.07-1.54.24-2.55.24H897.16a15,15,0,0,0-14.36,14.71h0v82.45H830.42V566.08h0c0-.58,0-1.16,0-1.75a37.93,37.93,0,0,1,37.93-37.93",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M849.83,413.13v-.06h65.61v-.24h5.44a9.16,9.16,0,0,0,2.08-.24,9.26,9.26,0,0,0,7.12-9v-81H987V422.88c0,.37,0,.74,0,1.12v.41l0,.73,0,.3c0,.38,0,.75-.06,1.06v.19c0,.35-.06.69-.1,1l0,.24c0,.28-.06.56-.1.83l0,.29-.15,1.09,0,.13c0,.33-.1.65-.16,1l-.07.4-.12.66-.07.32c-.07.34-.14.68-.22,1l-.08.29c-.06.28-.12.55-.19.82l-.1.37-.19.7-.08.3-.32,1.06-.3.94-.15.45-.32.87c-.12.35-.25.7-.39,1l-.41,1-.15.38-.39.88c-.14.3-.28.61-.45.95l-.42.86-.29.56-.4.76c-.17.31-.34.62-.52.92l-.48.82-.33.55-.46.73-.54.82-.51.73c-.14.21-.28.41-.43.61l-.08.12-.89,1.19-.11.14-.4.5-.18.22-.47.57-.1.12c-.51.6-1,1.19-1.57,1.77l-.64.68-.05,0c-.58.6-1.17,1.19-1.78,1.76l0,0a48.08,48.08,0,0,1-5.35,4.29l0,0a48,48,0,0,1-19.73,8v.61h-7.56v.05H861.79c-.82,0-1.64-.05-2.46-.05s-1.64,0-2.27,0l-6.06.38a82.06,82.06,0,0,0-73.71,81.63c0,.49,0,1,0,1.47l.11,5.54h-.15V679.35H720.34V537.71h.28A133.33,133.33,0,0,1,849.83,413.13",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M853.66,418.52h67.22v-.24a15,15,0,0,0,3.3-.37,14.66,14.66,0,0,0,11.35-14.21v-.06h0V328.07h46v94.81c0,.32,0,.65,0,1v.35l0,.69v.3q0,.48-.06,1v.12c0,.3,0,.6-.08.89l0,.25c0,.25-.05.49-.08.73l0,.29c0,.31-.09.62-.14.93v0l0,.08c0,.28-.08.57-.14.84l-.06.35-.12.61-.06.32c-.06.3-.12.59-.19.88l0,.07,0,.14-.18.75-.08.31-.18.65-.08.3c-.09.29-.17.58-.26.88l-.07.21-.21.64-.13.38-.22.62-.08.23c-.1.28-.21.56-.32.85l-.11.26-.25.63-.14.32-.24.53-.14.33c-.11.26-.24.52-.36.77l-.2.42-.18.35-.25.49-.21.39-.18.35c-.14.25-.28.51-.43.76l-.21.37-.21.35-.3.49-.14.23-.3.49-.43.64,0,0-.29.42-.18.27-.36.51-.09.1c-.26.38-.54.74-.82,1.1l0,.06-.37.46-.18.22c-.12.16-.25.32-.38.47l-.1.12c-.46.54-.92,1.06-1.4,1.58l-.09.1-.48.5,0,.05c-.51.53-1,1-1.59,1.55l0,0a43.51,43.51,0,0,1-4.74,3.82l0,0A42.66,42.66,0,0,1,941,465.64v.05h-7.55v.05H862c-.87,0-1.74-.05-2.62-.05s-1.75,0-2.62.05l-6.15.39a87.5,87.5,0,0,0-78.72,87c0,.53,0,1.05,0,1.57h-.05V673.91h-46V543.16h0A127.88,127.88,0,0,1,853.66,418.52",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1040.45,439.52c0,1.17.07,2.33.07,3.49a83.62,83.62,0,0,1-83.63,83.62H875.12c-2.83,0-5.33.08-8.29,0H866A35.33,35.33,0,0,0,830.69,562v117.4H771.63v-5.45q0-59.07-.09-118.16a90.38,90.38,0,0,1,84-90.13h.09l6.21-.23h.1q41,0,82,0A37.37,37.37,0,0,0,981.29,428V322.63h59.16Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M986.73,370.72V328.07H1035V439.63h0c0,1.12.08,2.24.08,3.38a78.19,78.19,0,0,1-78.19,78.18H866A40.76,40.76,0,0,0,825.25,562v.12c.08,23.26,0,46.9,0,70.29v41.54H777.07q0-59.07-.08-118.16a84.91,84.91,0,0,1,78.88-84.7l6-.21q41,0,82,0A42.81,42.81,0,0,0,986.73,428Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M853.66,418.52h67.22v-.24a14.65,14.65,0,0,0,14.65-14.58v-.06h0V328.07h46v94.81c0,.32,0,.65,0,1v.35l0,.69v.3q0,.48-.06,1v.12c0,.3,0,.6-.08.89l0,.25c0,.25-.05.49-.08.73l0,.29c0,.31-.09.62-.14.93v0l0,.08c0,.28-.08.57-.14.84l-.06.35-.12.61-.06.32c-.06.3-.12.59-.19.88l0,.07,0,.14-.18.75-.08.31-.18.65-.08.3c-.09.29-.17.58-.26.88l-.07.21-.21.64-.13.38-.22.62-.08.23c-.1.28-.21.56-.32.85l-.11.26-.25.63-.14.32-.24.53-.14.33c-.11.26-.24.52-.36.77l-.2.42-.18.35-.25.49-.21.39-.18.35c-.14.25-.28.51-.43.76l-.21.37-.21.35-.3.49-.14.23-.3.49-.43.64,0,0-.29.42-.18.27-.36.51-.09.1c-.26.38-.54.74-.82,1.1l0,.06-.37.46-.18.22c-.12.16-.25.32-.38.47l-.1.12c-.46.54-.92,1.06-1.4,1.58l-.09.1-.48.5,0,.05c-.51.53-1,1-1.59,1.55l0,0a43.51,43.51,0,0,1-4.74,3.82l0,0A42.66,42.66,0,0,1,941,465.64v.05h-7.55v.05H862c-.87,0-1.74-.05-2.62-.05s-1.75,0-2.62.05h-2.8c-44.53,0-82.07,43.19-82.07,87.44,0,.53,0,1.05,0,1.57h-.05V673.91h-46V543.16h0A127.88,127.88,0,0,1,853.66,418.52",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M986.73,370.72V328.07H1035V439.63h0c0,1.12.08,2.24.08,3.38a78.19,78.19,0,0,1-78.19,78.18H939.48c-24.43,0-48.92.14-73.32,0H866A40.76,40.76,0,0,0,825.25,562v.12c0,.87,0,1.72.09,2.57h-.09V673.91H777.07V559.67h0c-.06-1.3-.09-2.61-.09-3.92a84.91,84.91,0,0,1,77.68-84.6c2.23-.19,3.87-.31,6.44-.31h22.71l-.12-.32h55.43a44.64,44.64,0,0,0,4.79.27A42.81,42.81,0,0,0,986.73,428Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1470.74,162.65a16.08,16.08,0,1,1,16.07-16.07,16.09,16.09,0,0,1-16.07,16.07m0-29.47a13.4,13.4,0,1,0,13.4,13.4,13.42,13.42,0,0,0-13.4-13.4",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1477.67,144.12c0,2.55-1.11,4.15-3.33,4.82l4,5.6h-3.31l-3.69-5.18H1468v5.18h-2.61V139.11h5.74c2.36,0,4,.4,5.06,1.2a4.54,4.54,0,0,1,1.52,3.81m-3.47,2.19a2.73,2.73,0,0,0,.8-2.2,2.36,2.36,0,0,0-.81-2.07,5.43,5.43,0,0,0-2.92-.56H1468V147h3.24a4.73,4.73,0,0,0,3-.68",
    transform: "translate(0 0)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0102786cfda5c4f0ed7dc47f2bc99067.svg";
export { ForwardRef as ReactComponent };